
export class Scheduler {
  public id: number;
  public available: string;
  public start: string;
  public end: string;
  public groupid: string;
  public level: number;
  public sms: boolean;
  public mail: boolean;
  public voice: boolean;
  public office: boolean;
  public tag: string;

  constructor(
    id: number,
    available: string,
    start: string,
    end: string,
    groupid: string,
    level: number,
    sms: boolean,
    mail: boolean,
    voice: boolean,
    office: boolean,
    tag: string
  ) {
    this.id = id;
    this.available = available;
    this.start = start;
    this.end = end;
    this.groupid = groupid;
    this.level = level;
    this.office = office;
    this.sms = sms;
    this.mail = mail;
    this.voice = voice;
    this.tag = tag;
  }

}
